const CURRENCY_SYMBOLS = {
  BDT: "৳",
  USD: "$",
  EUR: "€",
  GBP: "£",
}

/**
 * Format an integer amount with the account's currency symbol.
 * Falls back to BDT (৳) when currency is unknown or omitted.
 *
 * @param {number|string|null} amount
 * @param {string} [currency="BDT"]
 * @returns {string}
 */
export function formatCurrency(amount, currency = "BDT") {
  if (amount == null || isNaN(Number(amount))) {
    return `${CURRENCY_SYMBOLS[currency] ?? currency} 0`
  }

  const symbol = CURRENCY_SYMBOLS[currency] ?? currency

  return (
    symbol +
    new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
      Number(amount)
    )
  )
}

/**
 * Shorthand that always uses BDT.
 */
export function formatBDT(amount) {
  return formatCurrency(amount, "BDT")
}
